export interface FaiProduct {
    id: number;
    sticker: string;
    hat: string;
    title: string;
    subtitle: string;
    logo_offre: string;
    image_alt: string;
    logo_alt: string;
    techno: string;
    slug: string;
    range: string;
    range_ng: RangesNewGeneration;
    commercial_series: string;
    gencode_offre: string;
    image_url: string;
    nuggets: {
        logo_nuggets: string;
        texte: string;
        show_speed: boolean;
        position: string;
    }[];
    details_url: string;
    fai_options: {
        items: {
            name: string;
            label: string;
            logo_url: string;
            logo_alt: string;
            id: number;
            order: string;
            fai_roc_options_id: number;
            fai_roc_products_id: number;
        }[];
    };
    product: {
        price: number;
        rental_fees: number;
        sku: string;
        speed_down: string;
        speed_up: string;
        obligation: string;
        fai_category_type: string;
        discounts: {
            type: string;
            value: number;
            discount: number;
            isIncitation: boolean;
            isDiffered: boolean;
            duration: number;
            pennant: string;
        }[];
        range: string;
        technology: string;
    };
    pre_elig_speed_up: null | number;
    pre_elig_speed_down: null | number;
    pre_elig_speed_wording?: string;
}

export enum RangesNewGeneration {
    VERY_FIT = 'very_fit',
    MUST = 'must',
}
